/**
 * Checks if a URL is a SIT1 environment URL.
 * SIT1 URLs have the form "https://something.something.sit1.com"
 */
export function isSit1Url(url: string) {
	return /^(?:[^.]*\.){2}sit1\./.test(url);
}
